<script setup lang="ts">
import { useStudentStore } from '@/stores/student';
import { useDisplay } from 'vuetify';
import { computed } from 'vue';
import { useThemes } from '@/composable/themes'
import image1 from '@images/backgrounds/background-4-mobile.jpg'
import image2 from '@images/backgrounds/background-5-mobile.jpg'
import image3 from '@images/backgrounds/background-2-mobile.jpg'

defineProps({
  location: {
    type: String,
    required: true,
  }
})

const studentStore = useStudentStore();
const { smAndDown } = useDisplay();

const { backgroundThemes } = useThemes()

const currentTheme = computed(() => {
  const theme = backgroundThemes.value.find(backgroundTheme => backgroundTheme.filename === studentStore.settings.background_image)

  return theme ? theme.name : 'Default'
})

const isMobile = computed(() => smAndDown.value);

const images = [image1, image2, image3]
</script>

<template>
  <VCard to="/themes" class="dashboard-card dashboard-card dashboard-card--theme-settings h-100 d-flex flex-column">
    <VCardText class="d-flex flex-column justify-space-between pa-0">
      <VRow no-gutters>
        <VCol cols="12" md="7" class="d-flex flex-column justify-space-between pb-4 px-4">
          <h2
            class="dashboard-card__title--theme-settings my-2 mt-3 font-museo d-flex flex-column d-md-block text-branding-grey text-center"
            :class="`font-${studentStore.fontStyle}`"
          >
            {{ $t('pages.dashboard.theme_settings.title') }}
        </h2>
          <VBtn to="/themes" variant="outlined" rounded="xl" class="dashboard-card__view-btn dashboard-card__view-btn--theme-settings mb-3" color="branding-grey">
            {{ $t('pages.dashboard.theme_settings.view_btn') }}
          </VBtn>
          <div v-if="location === 'settings'" class="text-center text-branding-grey">
            {{ $t('fields.current_theme') }}:
            {{ currentTheme }}
          </div>
        </VCol>
        <VCol cols="12" md="5" v-show="!isMobile">
          <div class="d-flex skewed-images h-100">
            <VImg :src="image1" alt="stacked" class="skewed-images__image" cover />
            <VImg :src="image2" alt="stacked" class="skewed-images__image" cover />
            <VImg :src="image3" alt="stacked" class="skewed-images__image" cover />
          </div>
        </VCol>
      </VRow>
    </VCardText>
  </VCard>
</template>

<style lang="scss" scoped>
.skewed-images {
  position: relative;
  transform: translateX(1.6rem);
  &__image {
    position: relative;
    flex: 1;
    transform: skewX(-15deg);
    overflow: hidden;
    margin-left: -1px;
    border-right: 5px solid white;

    &:last-child {
      border-right: none;
    }
  }
}
</style>
